import { RESOURCE_API_URL } from '../constances/server'
import axios from 'axios'
export function getFontList() {
  return axios.get(`${RESOURCE_API_URL}/Font/getList`)
}
